import { Routes, Route, Navigate } from 'react-router-dom';
import Nav from '@components/layout/Nav';
import Footer from '@components/layout/Footer';
import Home from '@pages/Home';
import About from '@pages/About';
import Services from '@pages/Services';
import Contact from '@pages/Contact';
import Portfolio from '@pages/Portfolio';
import PortfolioDetail from '@pages/PortfolioDetail';
import NotFound from '@pages/NotFound';

function App() {
  return (
    <>
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        {/* Accreditation merged into Services — keep old URL working via redirect */}
        <Route path="/accreditation" element={<Navigate to="/services" replace />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/portfolio" element={<Portfolio />} />
        {/* Boarding House rebranded to Luxury Co-living Development (2026-07) */}
        <Route
          path="/portfolio/boarding-house-coogee"
          element={<Navigate to="/portfolio/luxury-co-living-development-coogee" replace />}
        />
        <Route
          path="/portfolio/boarding-house-cronulla"
          element={<Navigate to="/portfolio/luxury-co-living-development-cronulla" replace />}
        />
        <Route path="/portfolio/:slug" element={<PortfolioDetail />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
